<template>
  <div class="d-flex align-items-center">
    <div class="side-frame-success mr-2"></div>
    <div>
      <span style="font-size: 14px; color: #606266">
        {{ $l('table_header_fabric') || '面料工价清单' }}
      </span>
    </div>
    <div v-if="!disabled">
      <el-divider direction="vertical"></el-divider>
      <b-button
        size="sm"
        variant="outline-success"
        @click="$emit('openEditForm', { type: 'add' })"
      >
        {{ $l('btn_addFabric') || '新增面料' }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  border-left: 3px solid $color-success;
  height: 26px;
  margin: 0;
  padding: 0;
}
</style>
